module.exports = __webpack_public_path__ + "img/15_66.21478578.png";